import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";
import { SERVICES } from "@/lib/content";

export default function Services() {
  return (
    <section className="bg-[var(--pta-cream)] pt-16 md:pt-24 pb-24">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="chapter-num">Our Services · Ten Verticals</div>
        <h1 className="font-serif-display text-6xl md:text-8xl text-[var(--pta-navy)] mt-4 leading-[0.95]">Services.<br /><em className="italic text-[var(--pta-gold)]">Fully catalogued.</em></h1>
        <p className="mt-8 max-w-2xl text-[var(--pta-ink)]/70 text-lg">From day-to-day accounting to fund-raise data rooms — organized under ten focused verticals so you know exactly where to start.</p>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.slug}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.04 }}
            >
              <Link
                to={`/services/${s.slug}`}
                data-testid={`services-link-${s.slug}`}
                className="pta-card block border hairline-navy bg-[var(--pta-cream)] p-8 md:p-10 h-full group"
              >
                <div className="flex items-start justify-between">
                  <div>
                    <div className="font-mono-fine text-[11px] tracking-[0.24em] text-[var(--pta-gold)]">{s.num} · Vertical</div>
                    <h2 className="font-serif-display text-3xl md:text-4xl text-[var(--pta-navy)] mt-3 leading-tight">{s.title}</h2>
                  </div>
                  <ArrowUpRight size={22} weight="bold" className="text-[var(--pta-navy)] group-hover:text-[var(--pta-gold)] transition-colors" />
                </div>
                <p className="mt-4 text-[var(--pta-ink)]/75 italic font-serif-display text-xl">{s.tagline}</p>
                <p className="mt-3 text-sm text-[var(--pta-ink)]/60">{s.for}</p>
                <div className="mt-6 flex flex-wrap gap-2">
                  {s.items.slice(0,6).map((it) => (
                    <span key={it} className="font-mono-fine text-[10px] tracking-[0.16em] uppercase px-2 py-1 border hairline text-[var(--pta-ink)]/70">{it}</span>
                  ))}
                  {s.items.length > 6 && <span className="font-mono-fine text-[10px] tracking-[0.16em] uppercase px-2 py-1 border hairline-gold text-[var(--pta-gold)]">+{s.items.length - 6} more</span>}
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
